import { ISelectOption } from '../../../UIPackage/MainModule/components/SelectInput';

export const newPlanSelectOption: ISelectOption = {
  id: 'NEW',
  label: 'Создать новый план',
  value: 'NEW',
};
